import React from "react";
import { useChatDependencyContext } from "../contexts/chat-dependency-context";
import { searchCompare } from "../utils/utils";
import useAllETUsersByIdsResolver from "./use-all-et-users-by-ids-resolver";

const reducer = (state, action) => {
  if (action.type === "POOL_RESULTS_FETCHED") {
    return { ...state, pool_search_results: action.payload, pool_search_results_loading: false };
  }
  if (action.type === "SAVE_POOL_RESULTS_TOTAL") {
    return { ...state, pool_search_results_total: action.payload };
  }

  if (action.type === "POOL_RESULTS_LOADING") {
    return { ...state, pool_search_results_loading: action.payload };
  }

  if (action.type === "UPDATE_SEARCH_VAL") {
    return { ...state, search_val: action.payload };
  }
  throw new Error("action type not defined");
};

const initial_state = {
  pool_search_results: [],
  search_val: "",
  pool_search_results_loading: false,
  pool_search_results_total: null,
};

const useChatSearch = ({ disablePools, poolIds }) => {
  const [state, dispatch] = React.useReducer(reducer, initial_state);
  const { getPools } = useChatDependencyContext();
  const { allUsersWithoutCurrentUser, idsLoading } = useAllETUsersByIdsResolver();

  React.useEffect(() => {
    if (disablePools) return;
    dispatch({ type: "POOL_RESULTS_LOADING", payload: true });
    getPools(state.search_val)
      .then(r => {
        dispatch({ type: "POOL_RESULTS_FETCHED", payload: r.items });
        if (!state.search_val) {
          dispatch({ type: "SAVE_POOL_RESULTS_TOTAL", payload: r.total || 0 });
        }
      })
      .catch(() => {
        dispatch({ type: "POOL_RESULTS_LOADING", payload: false });
      });
  }, [getPools, state.search_val, disablePools]);

  // we preload all users
  const filtered_users = React.useMemo(() => {
    return Object.values(allUsersWithoutCurrentUser).filter(user => {
      return searchCompare(user.name, state.search_val);
    });
  }, [allUsersWithoutCurrentUser, state.search_val]);

  const onSearchChange = val => dispatch({ type: "UPDATE_SEARCH_VAL", payload: val });

  return {
    onSearchChange,
    searchVal: state.search_val,
    pool_search_results: disablePools ? [] : state.pool_search_results,
    pool_search_results_loading: disablePools ? false : state.pool_search_results_loading,
    users: filtered_users,
    // ONLY if all users are loaded and empty and init pool call is loaded and its empty do we want to show the message.
    // we dont' care ab the filtered search resutls
    are_search_results:
      (Boolean(Object.keys(allUsersWithoutCurrentUser).length) && !idsLoading.length) ||
      (!state.pool_search_results_loading && typeof state.pool_search_results_total === "number"),
  };
};
export default useChatSearch;
